import { useFormikContext } from 'formik'

import { ImageInput } from 'src/components/form-title'
import { ICustomIconFile, ISetStockImage } from 'src/types'
import { imageChangeHandler } from 'src/common/handlers'
import { useState } from 'react'
import { ImageCropperModal } from '../image-cropper'

interface IProps {
  alt: string | null
}

export const FormImage = ({ alt }: IProps) => {
  const [imageToCrop, setImageToCrop] = useState<ICustomIconFile | null>(null)
  const [open, setOpen] = useState(false)

  const { values, errors, setFieldValue } = useFormikContext<{
    image: ICustomIconFile
    image_small: string | null
    image_medium: string | null
  }>()

  const handleClose = () => {
    setOpen(false)
    setImageToCrop(null)
  }

  const handleSetImage = (image: ICustomIconFile) => {
    setFieldValue('image', image)
    setFieldValue('image_small', null)
    setFieldValue('image_medium', null)
    setOpen(false)
    setImageToCrop(null)
  }

  const handleIconRemove = () => {
    setFieldValue('image', { icon: '', file: null })
    setFieldValue('image_small', null)
    setFieldValue('image_medium', null)
  }

  const handleImageChange = imageChangeHandler((data: ICustomIconFile) => {
    setOpen(true)
    setImageToCrop(data)
  })

  const handleStockImageSet: ISetStockImage = (img) => {
    setOpen(true)
    setImageToCrop({ icon: img, file: null })
  }

  return (
    <>
      <ImageInput
        handleStockImageSet={handleStockImageSet}
        alt={alt || 'image'}
        errorText={errors.image?.icon}
        handleImageChange={handleImageChange}
        image={values.image.file ? values.image.icon : values.image_medium || values.image.icon}
        isRound
        deleteImage={handleIconRemove}
        originalImage={values.image.icon}
      />
      <ImageCropperModal
        handleClose={handleClose}
        open={open}
        setImage={handleSetImage}
        imageToCrop={imageToCrop}
        initialAspectRatio={`${1 / 1}-Circle`}
      />
    </>
  )
}
